import { useClassNames } from '@magnetic/hooks';
import { IconContext } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import { InputClearButton } from './input-clear-button.js';
import { InputTooltip } from './input-tooltip.js';

const iconSizeMap = {
  lg: 16,
  md: 16,
  sm: 14
};
const InputFrame = forwardRef(
  ({
    children,
    className,
    disabled,
    fixedWidth,
    hasValue,
    hiddenLabel,
    invalid,
    label,
    onClear,
    optional,
    prefix,
    required,
    size = "md",
    suffix,
    tooltip
  }, ref) => {
    const classNames = useClassNames(
      "mds-rebuild-input-frame",
      `mds-rebuild-input-label-size-${size}`,
      className
    );
    const inputClassNames = useClassNames(
      "mds-rebuild-input",
      `mds-rebuild-input-size-${size}`,
      {
        "mds-rebuild-input-disabled": disabled,
        "mds-rebuild-input-invalid": invalid,
        "mds-rebuild-input-fixed-width": fixedWidth
      }
    );
    return /* @__PURE__ */ React.createElement(IconContext.Provider, {
      value: { size: iconSizeMap[size], weight: "bold" }
    }, /* @__PURE__ */ React.createElement("label", {
      className: classNames
    }, !hiddenLabel && /* @__PURE__ */ React.createElement("span", null, label, required && /* @__PURE__ */ React.createElement("span", {
      className: "mds-rebuild-input-label-required"
    }, "*"), optional && /* @__PURE__ */ React.createElement("span", {
      className: "mds-rebuild-input-label-optional"
    }, "(optional)"), tooltip && /* @__PURE__ */ React.createElement(InputTooltip, {
      tooltip
    })), /* @__PURE__ */ React.createElement("div", {
      className: inputClassNames,
      ref
    }, prefix, children, suffix, onClear && hasValue && !disabled && /* @__PURE__ */ React.createElement(InputClearButton, {
      onClear
    }))));
  }
);
InputFrame.displayName = "Input.Frame";

export { InputFrame };
//# sourceMappingURL=input-frame.js.map
